import { Link } from "react-router-dom";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useTranslation } from "react-i18next";
import secureLocalStorage from "react-secure-storage";

interface RowContextMenuProps {
    rowNavTo: string;
    isVisible: boolean;
    setIsVisible: (isVisible: boolean) => void;
    position: { x: number, y: number }
    row: any;
}

const RowContextMenu = ({ rowNavTo, isVisible, setIsVisible, position, row }: RowContextMenuProps) => {
    const { t } = useTranslation();

    const onClose = () => {
        setIsVisible(false)
    };

    return (
        <Menu
            id="row-context-menu"
            open={isVisible}
            onClose={onClose}
            anchorReference="anchorPosition"
            anchorPosition={isVisible ? { top: position.y, left: position.x } : undefined}
            onClick={(e) => e.stopPropagation()}
            onContextMenu={(event) => { onClose(); event.preventDefault(); }}
        >
            <Link to={rowNavTo} state={{ ...row }} target="_blank" style={{ textDecoration: 'none', color: 'black' }}
                onClick={() => {
                    secureLocalStorage.setItem("rowParam", { ...row });
                    onClose();
                }}
                onContextMenu={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                }}
            >
                <MenuItem
                    onContextMenu={(event) => event.preventDefault()}
                >
                    {t("table.contextMenu.newTab")}
                </MenuItem>
            </Link>

        </Menu>
    );
}

export default RowContextMenu;